__webpack_require__.p = "https://nice-mud-0ce01e21e.4.azurestaticapps.net/";